import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const primaryLinks = [
  { label: 'Home', path: '/' },
  { label: 'About Us', path: '/about' },
  { label: 'Contact', path: '/contact' },
];

const secondaryLinks = [
  { label: 'Terms', path: '/terms' },
  { label: 'Privacy', path: '/privacy' },
  { label: 'Delete Account', path: '/delete-account' },
];

const allLinks = [...primaryLinks, ...secondaryLinks];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <nav style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000,
      background: scrolled || !isHome ? 'rgba(255,255,255,0.97)' : 'transparent',
      backdropFilter: scrolled ? 'blur(10px)' : 'none',
      boxShadow: scrolled || !isHome ? '0 2px 20px rgba(0,0,0,0.08)' : 'none',
      transition: 'all 0.3s ease',
    }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: '70px' }}>

        {/* Logo */}
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div style={{
            width: '40px', height: '40px', borderRadius: '50%',
            background: 'linear-gradient(135deg, #C2185B, #AD1457)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: '9px',color: 'white',
      fontFamily: 'Agbalumo',
      fontWeight: 'bold',
          }}>
            weddyfyp
          </div>
          <span style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: '22px', fontWeight: '700',
            color: scrolled || !isHome ? '#C2185B' : (isHome ? '#C2185B' : '#C2185B'),
          }}>
            Weddyfyp matrimony
          </span>
        </Link>

        {/* Desktop Nav */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }} className="desktop-nav">
          {primaryLinks.map(link => (
            <Link key={link.path} to={link.path} style={{
              padding: '8px 14px', borderRadius: '8px',
              fontWeight: '500', fontSize: '14px',
              color: location.pathname === link.path ? '#C2185B' : '#4b5563',
              background: location.pathname === link.path ? '#fce4ec' : 'transparent',
              transition: 'all 0.2s',
            }}>
              {link.label}
            </Link>
          ))}
          <div style={{ width: '1px', height: '20px', background: '#e5e7eb', margin: '0 6px' }} />
          {secondaryLinks.map(link => (
            <Link key={link.path} to={link.path} style={{
              padding: '6px 10px', borderRadius: '6px',
              fontWeight: '400', fontSize: '13px',
              color: location.pathname === link.path ? '#C2185B' : '#9ca3af',
              background: location.pathname === link.path ? '#fce4ec' : 'transparent',
              transition: 'all 0.2s',
            }}>
              {link.label}
            </Link>
          ))}
          <a href="https://play.google.com/store" target="_blank" rel="noreferrer" style={{
            marginLeft: '8px', padding: '10px 20px', borderRadius: '25px',
            background: 'linear-gradient(135deg, #C2185B, #AD1457)',
            color: '#fff', fontWeight: '600', fontSize: '13px',
            boxShadow: '0 4px 15px rgba(194,24,91,0.3)',
            transition: 'transform 0.2s, box-shadow 0.2s',
            whiteSpace: 'nowrap',
          }}
            onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 6px 20px rgba(194,24,91,0.4)'; }}
            onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 15px rgba(194,24,91,0.3)'; }}
          >
            Start Your Journey
          </a>
        </div>

        {/* Hamburger */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          style={{
            display: 'none', background: 'none', border: 'none', cursor: 'pointer',
            flexDirection: 'column', gap: '5px', padding: '4px',
          }}
          className="hamburger"
          aria-label="Toggle menu"
        >
          {[0, 1, 2].map(i => (
            <span key={i} style={{
              display: 'block', width: '24px', height: '2px',
              background: '#C2185B', borderRadius: '2px',
              transition: 'all 0.3s',
              transform: menuOpen && i === 0 ? 'rotate(45deg) translate(5px, 5px)' :
                         menuOpen && i === 2 ? 'rotate(-45deg) translate(5px, -5px)' : 'none',
              opacity: menuOpen && i === 1 ? 0 : 1,
            }} />
          ))}
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div style={{
          background: '#fff', borderTop: '1px solid #e5e7eb',
          padding: '16px 24px 20px',
          boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
        }}>
          {allLinks.map(link => (
            <Link key={link.path} to={link.path} style={{
              display: 'block', padding: '11px 0', fontWeight: '500', fontSize: '15px',
              color: location.pathname === link.path ? '#C2185B' : '#374151',
              borderBottom: '1px solid #f3f4f6',
            }}>
              {link.label}
            </Link>
          ))}
          <a href="https://play.google.com/store" target="_blank" rel="noreferrer" style={{
            display: 'block', marginTop: '16px', padding: '12px', textAlign: 'center',
            borderRadius: '25px', background: 'linear-gradient(135deg, #C2185B, #AD1457)',
            color: '#fff', fontWeight: '600', fontSize: '15px',
          }}>
            Start Your Journey
          </a>
        </div>
      )}

      <style>{`
        @media (max-width: 768px) {
          .desktop-nav { display: none !important; }
          .hamburger { display: flex !important; }
        }
      `}</style>
    </nav>
  );
}
